'use client';
import { FC } from 'react';
import Typography from '@egalite/ui/Typography';
import { PrimaryButton, SecondaryButton } from '@egalite/ui/Buttons/GeneralButtons';
import Image from 'next/image';

const Hero: FC = () => {
    return (
        <section className="relative w-full pt-[24px] pb-[80px] bg-gradient-to-b from-slate-50 to-blue-50 overflow-hidden">
            <div className="max-w-[1280px] mx-auto px-8">
                <div className="flex flex-col lg:flex-row items-center gap-12">
                    <div className="flex-1 text-center lg:text-left">
                        <h1 
                            className="text-[#111827] mb-[24px] font-bold text-[40px] leading-[48px] md:text-[56px] md:leading-[56px] tracking-tight"
                        >
                            Conecte sua empresa a profissionais com deficiência
                        </h1>
                        <p 
                            className="text-[#4B5563] mb-[32px] text-[16px] md:text-[18px] leading-[1.625] max-w-[576px] mx-auto lg:mx-0"
                        >
                            A IncluiPcD é uma plataforma que aproxima empresas comprometidas
                            com a diversidade a profissionais com deficiência em busca de
                            oportunidades reais.
                        </p>
                        <div className="flex flex-col sm:flex-row items-center gap-[16px] justify-center lg:justify-start w-full">
                            <a href="#fale-conosco" className="inline-flex w-full sm:w-auto justify-center h-[52px] rounded-full px-[32px] text-[18px] font-bold items-center gap-2 bg-[#0F1DD7] text-white whitespace-nowrap group hover:bg-[#0F1DD7]/90 transition-colors cursor-pointer">
                                Fale com um especialista 
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-right group-hover:translate-x-1 transition-transform">
                                    <path d="M5 12h14"></path>
                                    <path d="m12 5 7 7-7 7"></path>
                                </svg>
                            </a>
                            <a 
                                href="#planos"
                                className="inline-flex w-full sm:w-auto items-center justify-center h-[52px] rounded-full px-[32px] text-[18px] font-semibold border-2 border-solid border-[#D1D5DB] bg-transparent text-[#374151] cursor-pointer hover:bg-transparent"
                            >
                                Ver planos
                            </a>
                        </div>
                    </div>
                    
                    <div className="flex-1 relative hidden lg:block">
                        <div className="relative z-10 rounded-[32px] overflow-hidden shadow-2xl lg:ml-8">
                            <Image
                                src="/office.jpeg"
                                alt="Time profissional e diverso"
                                width={800}
                                height={600}
                                priority
                                className="w-full h-auto object-cover"
                            />
                        </div>
                        

                        
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
